<div class="d-flex justify-content-between">
    <div>
        <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="d-flex gap-4 align-items-top">
        <div class="backIconContiner" (click)="backToPreviousPage()" (keydown.enter)="backToPreviousPage()"
            matTooltip="Go back">
            <i class="fa fa-arrow-left"></i>
        </div>
    </div>
</div>
<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="position-relative grid-content" style="margin-top: 10px;">
    <div>
        <div class="d-flex justify-content-between">
            <div class="d-flex align-items-center px-3">
                <div class="dropdown">
                </div>
            </div>
            <div class="d-flex gap-3">
                <div id="header-container">
                    <div class="">
                        <div class="search-container">
                            <span class="fa fa-search form-control-feedback"></span>
                            <input type="text" class="form-control search_input" style="font-size: 12px"
                                placeholder="Search here..." [(ngModel)]="searchValue" />
                        </div>
                    </div>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.dataGridAdmin" (click)="openReorder()" (keydown.enter)="openReorder()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20" fill="#ffffff">
                        <path style="fill:'#FFFFFF'"
                            d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
                    </svg>
                    <span class="reload_text text-white">Settings</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openAddPopup()" (keydown.enter)="openAddPopup()">
                    <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                    <span class="reload_text text-white">Add New</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('SECTION','Excel')" (keydown.enter)="openReport('SECTION','Excel')">
                    <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Excel Report</span>
                </div>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReport('SECTION','Pdf')" (keydown.enter)="openReport('SECTION','Pdf')">
                    <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">PDF Report</span>
                </div>
                <span *ngIf="grid?.length > 1"
                    class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="openReorderPopup('Section')" (keydown.enter)="openReorderPopup('Section')"
                    matTooltip="Reorder">
                    <img src="../../../assets/img/reorder.svg" width="18px" height="18px" alt="reorder" />
                    <span class="reload_text text-white">Reorder</span>
                </span>
                <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                    *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('SECTION','overAll',0)"
                    (click)="openAuditTrail('SECTION','overAll',0)">
                    <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                    <span class="reload_text text-white">Audit Trail</span>
                </div>
                <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                    (click)="refreshGridData()" (keydown.enter)="refreshGridData()">
                    <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                    <span class="reload_text">Reload</span>
                </div>
            </div>
        </div>
    </div>
    <div class="table-container">
        <table class="dynamic-table-container">
            <th style="min-width: 60px; text-align: center;"
                [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                <div style="display: flex;">
                    <div>
                        <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
                    </div>
                </div>
            </th>
            <th id="grid-header-container"
                *ngFor="let qmsReportTemplateSectionFieldData of tempFieldColumnArray; let ix = index;" [ngStyle]="{'min-width': qmsReportTemplateSectionFieldData.width,'max-width': qmsReportTemplateSectionFieldData.width,'overflow': 'hidden',
      'text-overflow': 'ellipsis',
      'white-space': 'nowrap'}" class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                    <span>{{ qmsReportTemplateSectionFieldData.fieldColumnarray }}</span>
                    <div class="d-flex gap-2 align-items-center">
                        <div (click)="sortColumn(columnLists.columnsListarray[ix],qmsReportTemplateSectionFieldData)"
                            (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],qmsReportTemplateSectionFieldData)">
                            <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                        </div>
                    </div>
                </div>
            </th>
            <th id="menu" class="sticky-col first-col"></th>
            <tr>
                <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                    [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                    class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                    <div class="row-search-container"><input type="text" class="form-control" placeholder="Search"
                            (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
                </td>
            </tr>
            <tr *ngFor="let list1 of pagedItems1 let idx = index;" [class.highlightRow]="list1.childCheckBoxs == true">
                <td style="min-width: 60px; text-align: center;background: white;"
                    [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                    <div style="display: flex;">
                        <div [ngClass]="list1.childCheckBoxs ?'static_icon':'hover-menu-icons'">
                            <i class="fa-solid fa-ellipsis-vertical"></i>
                        </div>
                        <div>
                            <input type="checkbox" style="zoom: 1.2;" [checked]="list1.childCheckBoxs"
                                (change)="dataGridChildCheckBoxChecked($event, list1, idx)">
                        </div>
                    </div>
                </td>
                <td id="grid-row-container" *ngFor="let key of tempColumnsListArray; let i = index;"
                    class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (focus)="focusEmpty()">
                    <span *ngIf="key.dataType=='CHECKBOX'">
                        <div class="gridCheckBoxes">
                            <img alt="access" *ngIf="list1[key.columnsListarray]" src="../../assets/img/accessSymbol.svg" width="20"
                                height="20">
                            <img alt="noaccess" *ngIf="list1[key.columnsListarray]==false" src="../../assets/img/noAcessSymbol.svg"
                                width="20" height="20">
                        </div>
                    </span>
                    <span
                        *ngIf="list1[key.columnsListarray]=='htmlClobView' || list1[key.columnsListarray]=='htmlClobView'">
                        <div class="download-button-continer btn-align" mat-dialog-actions>
                            <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                (click)="getClobData(list1,key.columnsListarray)">
                                <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                    alt="download">
                                <span class="ms-1">View</span>
                            </button>
                        </div>
                    </span>
                    <span
                        *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list1[key.columnsListarray] !='htmlClobView' && list1[key.columnsListarray] !='fileIspresentsa' && list1[key.columnsListarray] !='fileIsNotpresentsa' ">{{
                        list1[key.columnsListarray]
                        }}</span>
                    <span *ngIf="key.dataType=='DATE'">{{ list1[key.columnsListarray] }}</span>
                </td>
                <td class="sticky-col first-col">
                    <div class="action-icons">
                        <span class="qmsReportFieldGrid-container" matTooltip="Open {{reportFieldTooltipTitle}}"
                            style="margin-left: 5px;" (mouseover)="getRowData(list1)" (focus)="focusEmpty()"
                            (click)="openQmsReportFieldPopup(list1)" (keydown.enter)="openQmsReportFieldPopup(list1)"></span>
                        <i class="fa-solid fa-pencil" matTooltip="Edit QMS Report Template Section"
                            style="margin-left: 5px;" (keydown.enter)="openEditPopup(list1, true, 0)" (click)="openEditPopup(list1, true, 0)"></i>
                        <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete QMS Report Template Section"
                            style="margin-left: 5px;" (keydown.enter)="openDeletePopup(list1)" (click)="openDeletePopup(list1)"></i>
                        <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20"
                            height="20" src="../../assets/img/trail-individual.svg"
                            (click)="openAuditTrail('SECTION','individual',list1)" (keydown.enter)="openAuditTrail('SECTION','individual',list1)">
                    </div>
                </td>
            </tr>
        </table>
        <div class="d-flex justify-content-center">
            <div class="width-cheat small paginationCell">
                <div class="d-flex align-items-center gap-3">
                    <div class="pagination_text mt-3">
                        {{ showingRowsText }}
                        1-{{ perPage1 }} of {{ collectionSize1 | number }}
                    </div>
                    <div>
                        <ngb-pagination class="leftpadding" (pageChange)="setPage1(pager1.currentPage, $event)"
                            [disabled]="false" [collectionSize]="pager1.totalItems" [(page)]="pager1.currentPage"
                            [maxSize]="maxSize1" [rotate]="true" [pageSize]="perPage1" [ellipses]="false"
                            [boundaryLinks]="true" size="sm">
                        </ngb-pagination>
                    </div>
                    <div ngbDropdown class="mt-3">
                        <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                            ngbDropdownToggle>
                            {{ perPage1 }}
                            <i class="ms-1 fa-solid fa-chevron-down"></i>
                        </button>
                        <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                            <button ngbDropdownItem (click)="paginationCall1(10)">10</button>
                            <button ngbDropdownItem (click)="paginationCall1(20)">20</button>
                            <button ngbDropdownItem (click)="paginationCall1(50)">50</button>
                        </div>
                        per page
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #addAndEditPopup>
    <div class="ng-template-container">
        <div class="page-loading-shade" *ngIf="isProcessing">
            <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
        </div>
        <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
                class="fa popupClose">&#xf00d;</i></button>
        <div mat-dialog-title>
            <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
            <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
        </div>
        <div class="form-continer">
            <div class="row">
                <div class="col-md-4">
                    <!-- Is Flexi Field -->
                    <div><label for="email">Is Flexi Field?</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="qmsReportTemplateSectionFieldData.isFlexiField"
                        (change)="isFlexiFieldChange()">
                        <span class="active-inActive-container" *ngIf="qmsReportTemplateSectionFieldData.isFlexiField"
                            [ngStyle]="qmsReportTemplateSectionFieldData.isFlexiField?{'color':'green'} : {'color': ''}">Yes</span>
                        <span *ngIf="!qmsReportTemplateSectionFieldData.isFlexiField"
                            [ngStyle]="!qmsReportTemplateSectionFieldData.isFlexiField?{'color':'red'} : {'color': ''}">No</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-4" *ngIf="qmsReportTemplateSectionFieldData.isFlexiField">
                    <div><label for="email">Group Name</label></div>
                    <!-- Show dropdown when visibleGroupName is true -->
                    <mat-select *ngIf="visibleGroupName" matInput multiple placeholder="Select" #groupIds
                        [(ngModel)]="groupIdsValues" (closed)="typeSearchText=''"
                        (click)="focusSearch('groupIdsfocusSearch')" (keydown.enter)="focusSearch('groupIdsfocusSearch')">
                        <input type="search" id="groupIdsfocusSearch" class="dropdownsearchstyle"
                            [(ngModel)]="typeSearchText" matInput placeholder="search">
                        <mat-option *ngFor="let item of groupDropdown | assessmentSearch : typeSearchText"
                            [value]="item.valueExp" (onSelectionChange)="onGroupIdsSelect($event,item)">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>

                    <!-- Show disabled input with selected value when visibleGroupName is false -->
                    <div *ngIf="!visibleGroupName"
                        style="background-color: #f5f5f5; padding: 10px; border-radius: 4px; font-size: 14px; color: #333; width: 100%; box-sizing: border-box;">
                        {{ message.groupNameFromQmsReportTemplate }}
                    </div>
                </div>
            </div>
            <div class="row" *ngIf="this.selectedReportSectionRowData==undefined">
                <div class="col-md-4">
                    <!-- Report Section Name -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_NAME']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>

                    <mat-select placeholder="Select" [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionName"
                        (closed)="pdfDetailSearchText1=''" (click)="focusSearch('reportSectionName')" (keydown.enter)="focusSearch('reportSectionName')">
                        <input type="search" id="reportSectionName" class="dropdownsearchstyle"
                            [(ngModel)]="pdfDetailSearchText1" placeholder="search">
                        <mat-option *ngFor="let item of sectionList | assessmentSearch : pdfDetailSearchText1"
                            (onSelectionChange)="onColumnsValueSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                    <span id="reportSectionName-required-msg">Please select the Report Section Name</span>
                </div>

                <div class="col-md-4">
                    <!-- Report Section Label Name  -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_LABEL_NAME']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers" type="text" id="reportSectionLabelName"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionLabelName">
                    <span id="reportSectionLabelName-required-msg">Please enter the Report Section Label
                        Name</span>
                </div>
                <div class="col-md-4">
                    <!-- Report Section Order -->
                    <div><label for="email ">{{dynamicLabel['REPORT_SECTION_ORDER']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers uppercase" type="number" min="1" id="reportSectionOrder"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionOrder"
                        (keydown)="validateNumberFields($event)">
                    <span id="reportSectionOrder-required-msg">Please enter the Report Section Order</span>
                </div>

                <div class="col-md-6">
                    <!-- Report Section Header Content -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_HEADER_CONTENT']}}</label></div>
                    <textarea type="text" class="input-filed-textarea" style="width: 100%;" rows="4" cols="50"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionHeaderContent"></textarea>
                </div>
                <div class="col-md-6">
                    <!-- Report Section Footer Content -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_FOOTER_CONTENT']}}</label></div>
                    <textarea type="text" class="input-filed-textarea" style="width: 100%;" rows="4" cols="50"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionFooterContent"></textarea>
                </div>
                <div class="col-md-6" *ngIf="visibleEditButton">
                    <div><label for="email">Update Reason</label><span class="mandatory-symbol">*</span>
                    </div>
                    <textarea id="update-text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.updateReason"></textarea>
                    <span id="update-required-msg">Please enter the update reason</span>
                </div>
            </div>
            <div class="row" *ngIf="this.selectedReportSectionRowData!=undefined">
                <div class="col-md-4">
                    <!-- Report Field Name -->
                    <div><label for="email">{{dynamicLabel['REPORT_FIELD_NAME']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <mat-select placeholder="Select" [(ngModel)]="qmsReportTemplateSectionFieldData.reportFieldName"
                        (closed)="pdfDetailSearchText=''" (click)="focusSearch('reportFieldName')" (keydown.enter)="focusSearch('reportFieldName')">
                        <input type="search" id="reportFieldName" class="dropdownsearchstyle"
                            [(ngModel)]="pdfDetailSearchText" placeholder="search">
                        <mat-option *ngFor="let item of columnListDropdown | assessmentSearch : pdfDetailSearchText"
                            (onSelectionChange)="onColumnsValueSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                    <span id="reportFieldName-required-msg">Please enter the Report Field Name</span>
                </div>
                <div class="col-md-4">
                    <!-- Report Field Label Name -->
                    <div><label for="email">{{dynamicLabel['REPORT_FIELD_LABEL_NAME']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers " type="text" id="reportFieldLabelName"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportFieldLabelName">
                    <span id="reportFieldLabelName-required-msg">Please enter the Report Field Label
                        Name</span>
                </div>
                <div class="col-md-4">
                    <!-- Report Section Field Order -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_FIELD_ORDER']}}</label><span
                            class="mandatory-symbol">*</span>
                    </div>
                    <input class="input-filed-continers uppercase" type="number" min="1" id="reportSectionFieldOrder"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionFieldOrder"
                        (keydown)="validateNumberFields($event)">
                    <span id="reportSectionFieldOrder-required-msg">Please enter the Report Section Field
                        Order</span>
                </div>
                <div class="col-md-4">
                    <!-- Report Section Field at Full Row -->
                    <div><label for="email">{{dynamicLabel['REPORT_SECTION_FIELD_AT_FULL_ROW']}}</label></div>
                    <mat-slide-toggle color="primary"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow">
                        <span class="active-inActive-container"
                            *ngIf="qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow"
                            [ngStyle]="qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow?{'color':'green'} : {'color': ''}">Yes</span>
                        <span *ngIf="!qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow"
                            [ngStyle]="!qmsReportTemplateSectionFieldData.reportSectionFieldAtFullRow?{'color':'red'} : {'color': ''}">No</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-4">
                    <!-- Show Only if Not Null  -->
                    <div><label for="email">{{dynamicLabel['SHOW_ONLY_IF_NOT_NULL']}}</label></div>
                    <mat-slide-toggle color="primary" [(ngModel)]="qmsReportTemplateSectionFieldData.showOnlyIfNotNull">
                        <span class="active-inActive-container"
                            *ngIf="qmsReportTemplateSectionFieldData.showOnlyIfNotNull"
                            [ngStyle]="qmsReportTemplateSectionFieldData.showOnlyIfNotNull?{'color':'green'} : {'color': ''}">Yes</span>
                        <span *ngIf="!qmsReportTemplateSectionFieldData.showOnlyIfNotNull"
                            [ngStyle]="!qmsReportTemplateSectionFieldData.showOnlyIfNotNull?{'color':'red'} : {'color': ''}">No</span>
                    </mat-slide-toggle>
                </div>
                <div class="col-md-4">
                    <!-- Include/Exclude  -->
                    <div><label for="email">{{dynamicLabel['INCLUDE_EXCLUDE_FLAG']}}</label></div>
                    <mat-slide-toggle color="primary"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.includeExcludeFlag">
                        <span class="active-inActive-container"
                            *ngIf="qmsReportTemplateSectionFieldData.includeExcludeFlag"
                            [ngStyle]="qmsReportTemplateSectionFieldData.includeExcludeFlag?{'color':'green'} : {'color': ''}">Include</span>
                        <span *ngIf="!qmsReportTemplateSectionFieldData.includeExcludeFlag"
                            [ngStyle]="!qmsReportTemplateSectionFieldData.includeExcludeFlag?{'color':'red'} : {'color': ''}">Exclude</span>
                    </mat-slide-toggle>
                </div>

            </div>


        </div>
    </div>
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="addAndEditFunction(qmsReportTemplateSectionFieldData)" (keydown.enter)="addAndEditFunction(qmsReportTemplateSectionFieldData)" *ngIf="visibleAddButton">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (keydown.enter)="addAndEditFunction(qmsReportTemplateSectionFieldData)"(click)="addAndEditFunction(qmsReportTemplateSectionFieldData)" *ngIf="visibleEditButton">
            <i class="fas fa-user-edit" style="font-size: 18px;color: white;"></i>
            <span class="reload_text text-white">Update</span>
        </div>
        <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div><label for="email">Reason for Delete</label><span class="mandatory-symbol">*</span></div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea uppercase"
                        style="width: 100%;" rows="4" cols="50"
                        [(ngModel)]="qmsReportTemplateSectionFieldData.deleteReason"></textarea>
                    <span id="deleteTextarea-required-msg">Please provide the reason for delete</span>
                </div>
            </div>
        </div>

        <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="selectedCount < 1" (click)="deleteFunction(qmsReportTemplateSectionFieldData)" (keydown.enter)="deleteFunction(qmsReportTemplateSectionFieldData)">
                <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
                <span class="reload_text text-white">Delete</span>
            </div>
            <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                *ngIf="selectedCount > 0" (click)="multiDeleteFunction()" (keydown.enter)="multiDeleteFunction()">
                <i class="fa fa-trash" style="font-size: 18px;color: white;"></i>
                <span class="reload_text text-white">Delete</span>
            </div>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #qmsReportFieldGridPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelQmsReportFieldGridPopupFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ reportFieldTooltipTitle }} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="position-relative grid-content" style="margin-top: 10px;">
        <div>
            <div class="d-flex justify-content-between">
                <div class="d-flex align-items-center px-3">
                    <div class="dropdown">
                    </div>
                </div>
                <div class="d-flex gap-3">
                    <div class="header-container">
                        <div class="">
                            <div class="search-container">
                                <span class="fa fa-search form-control-feedback"></span>
                                <input type="text" class="form-control search_input" style="font-size: 12px"
                                    placeholder="Search here..." [(ngModel)]="searchValue" />
                            </div>
                        </div>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        matTooltip="Settings" *ngIf="message.dataGridAdmin" (click)="openReorder()"  (keydown.enter)="openReorder()">
                        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 20 20"
                            fill="#ffffff">
                            <path style="fill:'#FFFFFF'"
                                d="M10 6.66666C10.8841 6.66666 11.7319 7.01785 12.357 7.64297C12.9822 8.2681 13.3333 9.11594 13.3333 10C13.3333 10.8841 12.9822 11.7319 12.357 12.357C11.7319 12.9821 10.8841 13.3333 10 13.3333C9.11596 13.3333 8.26811 12.9821 7.64299 12.357C7.01787 11.7319 6.66668 10.8841 6.66668 10C6.66668 9.11594 7.01787 8.2681 7.64299 7.64297C8.26811 7.01785 9.11596 6.66666 10 6.66666ZM10 8.33333C9.55799 8.33333 9.13406 8.50893 8.8215 8.82149C8.50894 9.13405 8.33335 9.55797 8.33335 10C8.33335 10.442 8.50894 10.8659 8.8215 11.1785C9.13406 11.4911 9.55799 11.6667 10 11.6667C10.442 11.6667 10.866 11.4911 11.1785 11.1785C11.4911 10.8659 11.6667 10.442 11.6667 10C11.6667 9.55797 11.4911 9.13405 11.1785 8.82149C10.866 8.50893 10.442 8.33333 10 8.33333ZM8.33335 18.3333C8.12501 18.3333 7.95001 18.1833 7.91668 17.9833L7.60835 15.775C7.08335 15.5667 6.63335 15.2833 6.20001 14.95L4.12501 15.7917C3.94168 15.8583 3.71668 15.7917 3.61668 15.6083L1.95001 12.725C1.89901 12.6391 1.88103 12.5376 1.89943 12.4395C1.91784 12.3413 1.97137 12.2532 2.05001 12.1917L3.80835 10.8083L3.75001 10L3.80835 9.16666L2.05001 7.80833C1.97137 7.74678 1.91784 7.65868 1.89943 7.56052C1.88103 7.46236 1.89901 7.36086 1.95001 7.275L3.61668 4.39166C3.71668 4.20833 3.94168 4.13333 4.12501 4.20833L6.20001 5.04166C6.63335 4.71666 7.08335 4.43333 7.60835 4.225L7.91668 2.01666C7.95001 1.81666 8.12501 1.66666 8.33335 1.66666H11.6667C11.875 1.66666 12.05 1.81666 12.0833 2.01666L12.3917 4.225C12.9167 4.43333 13.3667 4.71666 13.8 5.04166L15.875 4.20833C16.0583 4.13333 16.2833 4.20833 16.3833 4.39166L18.05 7.275C18.1583 7.45833 18.1084 7.68333 17.95 7.80833L16.1917 9.16666L16.25 10L16.1917 10.8333L17.95 12.1917C18.1084 12.3167 18.1583 12.5417 18.05 12.725L16.3833 15.6083C16.2833 15.7917 16.0583 15.8667 15.875 15.7917L13.8 14.9583C13.3667 15.2833 12.9167 15.5667 12.3917 15.775L12.0833 17.9833C12.05 18.1833 11.875 18.3333 11.6667 18.3333H8.33335ZM9.37501 3.33333L9.06668 5.50833C8.06668 5.71666 7.18335 6.25 6.54168 6.99166L4.53335 6.125L3.90835 7.20833L5.66668 8.5C5.33335 9.47222 5.33335 10.5278 5.66668 11.5L3.90001 12.8L4.52501 13.8833L6.55001 13.0167C7.19168 13.75 8.06668 14.2833 9.05835 14.4833L9.36668 16.6667H10.6333L10.9417 14.4917C11.9333 14.2833 12.8083 13.75 13.45 13.0167L15.475 13.8833L16.1 12.8L14.3333 11.5083C14.6667 10.5333 14.6667 9.475 14.3333 8.5L16.0917 7.20833L15.4667 6.125L13.4583 6.99166C12.8035 6.2336 11.9153 5.71473 10.9333 5.51666L10.625 3.33333H9.37501Z" />
                        </svg>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="openAddPopup()" (keydown.enter)="openAddPopup()">
                        <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
                        <span class="reload_text text-white">Add New</span>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="openReport('FIELD','Excel')" (keydown.enter)="openReport('FIELD','Excel')">
                        <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white">Excel Report</span>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="openReport('FIELD','Pdf')" (keydown.enter)="openReport('FIELD','Pdf')">
                        <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white">PDF Report</span>
                    </div>
                    <span *ngIf="grid?.length > 1"
                        class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="openReorderPopup('Field')" (keydown.enter)="openReorderPopup('Field')" matTooltip="Reorder" matTooltip="Reorder">
                        <img src="../../../assets/img/reorder.svg" width="18px" height="18px" alt="reorder" />
                        <span class="reload_text text-white"></span>
                    </span>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        *ngIf="message.isAuditTrailUser" (keydown.enter)="openAuditTrail('FIELD','overAll',0)"
                         (click)="openAuditTrail('FIELD','overAll',0)">
                        <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
                        <span class="reload_text text-white"></span>
                    </div>
                    <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="multiDelete()" (keydown.enter)="multiDelete()" *ngIf="selectedCount > 0" matTooltip="Delete Multiple Records">
                        <i class="fa-sharp fa-solid fa-trash" style="font-size:18px;color:white"></i>
                    </div>
                    <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
                        (click)="refreshGridData()"  (keydown.enter)="refreshGridData()">
                        <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
                        <span class="reload_text">Reload</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="table-container">
            <table style="max-height: 55vh !important;">
                <thead>
                    <th style="min-width: 60px; text-align: center;"
                        [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                        <div style="display: flex;">
                            <div>
                                <i class="fa-solid fa-ellipsis-vertical parent-menu-icons"></i>
                            </div>
                            <div>
                                <input type="checkbox" style="zoom: 1.2;" [checked]="parentCheckBox"
                                    (change)="dataGridParentCheckBoxChecked($event)">
                            </div>
                        </div>
                    </th>
                    <th 
                        *ngFor="let qmsReportTemplateSectionData of columnLists.fieldColumnarray; let ix = index;"
                        [ngStyle]="{
                'min-width': qmsReportTemplateSectionData.width,
                'max-width': qmsReportTemplateSectionData.width,'overflow': 'hidden',
                'text-overflow': 'ellipsis',
                'white-space': 'nowrap'}" class="sticky-dynamic-col1 grid-header-container" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                       
                        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                            <span>{{ qmsReportTemplateSectionData.fieldColumnarray }}</span>
                            <div class="d-flex gap-2 align-items-center">
                                <div
                                    (click)="sortColumn(columnLists.columnsListarray[ix],qmsReportTemplateSectionData)"
                                    (keydown.enter)="sortColumn(columnLists.columnsListarray[ix],qmsReportTemplateSectionData)">
                                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px"
                                        alt="sort" />
                                </div>

                            </div>
                        </div>
                    </th>
                    <th class="sticky-col first-col menu"></th>
                </thead>
                <tbody>
                    <tr>
                        <td [class]="  makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' "></td>
                        <td *ngFor=" let oneQmsUsersDataForTable1Data of columnLists.fieldColumnarray; let ix = index "
                            [ngStyle]="{ 'min-width': oneQmsUsersDataForTable1Data.width != null ? oneQmsUsersDataForTable1Data.width : '200px' }"
                            class="sticky-dynamic-col1" (mouseover)="cssfunction(0)" (focus)="focusEmpty()">
                            <div class="row-search-container"><input type="text" class="form-control"
                                    placeholder="Search"
                                    (input)="applyFilter3(columnLists.columnsListarray[ix], $event)" /> </div>
                        </td>
                    </tr>
                    <tr *ngFor="let list2 of pagedItems2 let idx = index;"
                        [class.highlightRow]="list2.sectionFieldChildCheckBoxs == true">
                        <td style="min-width: 60px; text-align: center;background: white;"
                            [class]="makeStickyColumns != -1 ? 'sticky-checkbox-col checkbox-col' : '' ">
                            <div style="display: flex;">
                                <div [ngClass]="list2.sectionFieldChildCheckBoxs ?'static_icon':'hover-menu-icons'">
                                    <i class="fa-solid fa-ellipsis-vertical"></i>
                                </div>
                                <div>
                                    <input type="checkbox" style="zoom: 1.2;"
                                        [checked]="list2.sectionFieldChildCheckBoxs"
                                        (change)="sectionFieldDataGridChildCheckBoxChecked($event, list2, idx)">
                                </div>
                            </div>
                        </td>
                        <td class="grid-row-container" *ngFor="let key of columnLists.columnsListarray1; let i = index;"
                            class="sticky-dynamic-row1" [ngStyle]="{'min-width': key.width[i],'max-width': key.width[i],'overflow': 'hidden',
                    'text-overflow': 'ellipsis',
                    'white-space': 'nowrap'}" (mouseover)="cssfunction(i)" (focus)="focusEmpty()">
                            <span *ngIf="key.dataType=='CHECKBOX'">
                                <div class="gridCheckBoxes">
                                    <img alt="access" *ngIf="list2[key.columnsListarray]" src="../../assets/img/accessSymbol.svg"
                                        width="20" height="20">
                                    <img alt="noaccess"*ngIf="list2[key.columnsListarray]==false"
                                        src="../../assets/img/noAcessSymbol.svg" width="20" height="20">
                                </div>
                            </span>
                            <span
                                *ngIf="list2[key.columnsListarray]=='htmlClobView' || list2[key.columnsListarray]=='htmlClobView'">
                                <div class="download-button-continer btn-align" mat-dialog-actions>
                                    <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                                        (click)="getClobData(list2,key.columnsListarray)">
                                        <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px"
                                            alt="download">
                                        <span class="ms-1">View</span>
                                    </button>
                                </div>
                            </span>
                            <span
                                *ngIf="key.dataType!='CHECKBOX' && key.dataType!='DATE' && list2[key.columnsListarray] !='htmlClobView' && list2[key.columnsListarray] !='fileIspresentsa' && list2[key.columnsListarray] !='fileIsNotpresentsa' ">{{
                                list2[key.columnsListarray]
                                }}</span>
                            <span *ngIf="key.dataType=='DATE'">{{ list2[key.columnsListarray] }}</span>
                        </td>
                        <td class="sticky-col first-col">
                            <div class="action-icons">
                                <i class="fa-solid fa-pencil" matTooltip="Edit {{reportFieldTooltipTitle}}"
                                    style="margin-left: 5px;" (click)="openEditPopup2(list2)" (keydown.enter)="openEditPopup2(list2)"></i>
                                <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete {{reportFieldTooltipTitle}}"
                                    style="margin-left: 5px;" (click)="openDeletePopup(list2)" (keydown.enter)="openDeletePopup(list2)"></i>
                                <img *ngIf="message.isAuditTrailUser" matTooltip="Audit Trail" alt="Trail" width="20"
                                    height="20" src="../../assets/img/trail-individual.svg"
                                    (click)="openAuditTrail('FIELD','individual',list2)"(keydown.enter)="openAuditTrail('FIELD','individual',list2)">
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div class="d-flex justify-content-center">
                <div class="width-cheat small paginationCell">
                    <div class="d-flex align-items-center gap-3">
                        <div class="pagination_text mt-3">
                            {{ showingRowsText }}
                            1-{{ perPage2 }} of {{ collectionSize2 | number }}
                        </div>
                        <div>
                            <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager2.currentPage, $event)"
                                [disabled]="false" [collectionSize]="pager2.totalItems" [(page)]="pager2.currentPage"
                                [maxSize]="maxSize2" [rotate]="true" [pageSize]="perPage2" [ellipses]="false"
                                [boundaryLinks]="true" size="sm">
                            </ngb-pagination>
                        </div>
                        <div ngbDropdown class="mt-3">
                            <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" class="dropdownBasic1"
                                ngbDropdownToggle>
                                {{ perPage2 }}
                                <i class="ms-1 fa-solid fa-chevron-down"></i>
                            </button>
                            <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                                <button ngbDropdownItem (click)="paginationCall2(10)">10</button>
                                <button ngbDropdownItem (click)="paginationCall2(20)">20</button>
                                <button ngbDropdownItem (click)="paginationCall2(50)">50</button>
                            </div>
                            per page
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #reorderPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelReorder()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{reorderTitle}} </label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <b class="align-center">
            <!-- s for section | f for field -->
            Drag and drop to reorder the {{ !s_or_f ?'Report Section' : 'Report Section Field' }}
        </b>
        <div class="table-container">
            <table style="max-height: 65vh;">
                <thead>
                    <th class="control-text" style="width: 240px; text-align: center;">
                        <span>
                            {{ !s_or_f ?'Report Section Order' : 'Report Section Field Order' }}
                        </span>
                        <span class="grid-header-container"> </span>
                    </th>
                    <th class="control-text" style="width: 240px; text-align: left;">
                        <span>
                            {{ !s_or_f ? 'Report Section Name' : 'Report Section Field Name' }}
                        </span>
                        <span class="grid-header-container"> </span>
                    </th>
                    <th class="control-text" style="width: 150px; text-align: left;">
                        <span>New Order</span>
                        <span class="grid-header-container"></span>
                    </th>
                </thead>
                <tbody cdkDropList (cdkDropListDropped)="dragAndDrop($event)">
                    <tr cdkDrag cdkDragLockAxis="y" cdkDragHandle *ngFor="let i of grid let idx = index;">
                        <td class="control-text" style="width: 240px; text-align: center;">
                            <span>
                                {{ !s_or_f ? i.REPORT_SECTION_ORDER : i.REPORT_SECTION_FIELD_ORDER }}
                            </span>
                        </td>
                        <td class="control-text" style="text-align: left;">
                            <span>
                                {{ !s_or_f ? i.REPORT_SECTION_NAME : i.REPORT_FIELD_NAME }}
                            </span>
                        </td>
                        <td class="control-text" style="text-align: left;">
                            <span>{{i.NEW_ORDER}}</span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="reorderSectionOrField()" [disabled]="!isReordered">
                <i class="fa fa-redorder"></i> Reorder
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelReorder()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<app-dynamic-audit-trail #dynAuditTrailPopup [auditTrail]="auditTrail"></app-dynamic-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-editor #clobViewPopup></app-editor>
<app-grid-reorder #reorderPopup (valueEmitter)="onChildValueEmitted()"></app-grid-reorder>